<template>
  <!--  <div class="text" :style="{-->
  <!--    '&#45;&#45;color': color,-->
  <!--    '&#45;&#45;hover-color': hoverColor-->
  <!--  }" @click="$emit('click')">-->
  <!--    {{ values }}-->
  <!--  </div>-->
  <div class="text" @click="$emit('click')">
    {{ values }}
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#333'
    },
    hoverColor: {
      type: String,
      default: '#333'
    }
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {
    values: {
      get() {
        return this.text
      },
      set(val) {
        this.$emit('update:text', val)
      }
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">
//.text {
//  color: var(--color);
//
//  &:hover {
//    color: var(--hover-color);
//  }
//}
</style>

